export const verify = {
    email: 'Verifying email',
    noParamsError: 'Missing the necessary parameters (verificationId or verificationToken)',
    inProgress: 'The email address update process is in progress.',
    successChangeEmail: 'The email change process has been successful. You will be redirected to the homepage.',
    title: 'E-mail Address Change',
    loginPage: 'login',
    oldEmail: 'Old Email Address',
    newEmail: 'New Email Address'
}
